import styled from 'styled-components';
import { Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { NAV_HEIGHT } from '../consts';

export const Container = styled.div`
  overflow: hidden;
`;

export const Wrapper = styled.div<{ animate: boolean; show?: boolean; canBeHiddenInline?: boolean }>`
  white-space: nowrap;

  ${({ animate, canBeHiddenInline, show }) => {
    const showAnimation = `transition: transform  ${Transition.Time.BASE} ${
      canBeHiddenInline ? Transition.Time.BASE : '0s'
    }, max-width ${Transition.Time.BASE};`;
    const hideAnimation = `transition: transform  ${Transition.Time.BASE}, max-width ${Transition.Time.BASE};`;
    const animation = show ? showAnimation : hideAnimation;
    const hiddenTransform = canBeHiddenInline ? 0 : NAV_HEIGHT;
    const shownWidth = canBeHiddenInline ? '160px' : 'auto';
    const hiddenWidth = canBeHiddenInline ? '0px' : 'auto';
    return `
      max-width: ${show ? shownWidth : hiddenWidth};
      transform: ${show ? `translateY(0px)` : `translateY(${hiddenTransform})`};
      ${animate ? animation : ``}
  `;
  }}

  ${({ animate, show }) =>
    Mixins.Media.maxWidthLarge(`
    margin-left: ${show ? `-${Spacing.QUARTER}` : `0px`} ;
    margin-right: ${show ? `-${Spacing.QUARTER}` : `0px`} ;
    transform: ${show ? `translateY(0px)` : `translateY(${NAV_HEIGHT})`};
    max-width: ${show ? `100vw` : `0px`} !important;
    ${animate ? `transform ${Transition.Time.BASE}, max-width ${Transition.Time.BASE}; !important` : ``}
  `)}
`;
